import { SxProps, Theme } from '@mui/material';

import { Icons, IconTypes } from './HBIcon.data';
import { HBIconRootStyle, HBIconStyleProps } from './HBIcon.styles';

export type HBIconType = (typeof IconTypes)[number];
export { IconTypes };
export interface HBIconProps {
  size?: HBIconStyleProps['size'];
  type: HBIconType;
  style?: React.CSSProperties;
  sx?: SxProps<Theme>;
  className?: string;
}

export const HBIcon = ({
  type,
  size = 'medium',
  className,
  ...props
}: HBIconProps): JSX.Element => {
  return <HBIconRootStyle size={size} className={`${Icons[type]} ${className}`} {...props} />;
};
